import type { RouteRecordRaw } from "vue-router";
import { personLoginGuard } from "@/apps/person-registration/login/router/routeGuards";
import { loginTranslationGuard } from "@/router/translationGuards";

// Lazy-loaded view components for code splitting
const PersonLoginView = () => import("@/apps/person-registration/login/views/PersonLoginView.vue");
const ResetPasswordRequestView = () =>
	import("@/apps/person-registration/login/views/ResetPasswordRequestView.vue");
const PasswordResetView = () =>
	import("@/apps/person-registration/login/views/PasswordResetView.vue");

const routes: Array<RouteRecordRaw> = [
	{
		path: "/accounts/login",
		name: "PersonLoginView",
		component: PersonLoginView,
		beforeEnter: [personLoginGuard, loginTranslationGuard],
	},
	{
		path: "/accounts/reset-password-request",
		name: "ResetPasswordRequestView",
		component: ResetPasswordRequestView,
		beforeEnter: [loginTranslationGuard],
	},
	{
		path: "/accounts/password-reset",
		name: "PasswordResetView",
		component: PasswordResetView,
		beforeEnter: [loginTranslationGuard],
	},
];

export default routes;
